import { useState } from "react";
import { Filter, FilterX } from "lucide-react";
import { FLOW_TEXT_INPUT_BASE } from "../../styles/twDesignPrimitives";
import { PropertiesCodeSearchField } from "./PropertiesCodeSearchField";
import { PropertiesListFiltersModal } from "./PropertiesListFiltersModal";
import {
  countAdvancedPropertyListFilters,
  emptyPropertyListAdvancedFilters,
  type PropertyListAdvancedFilters,
  type PropertyListFilters,
} from "./propertiesListQuery";

const FILTER_ACTION_BUTTON =
  "inline-flex h-[38px] shrink-0 items-center justify-center gap-2 rounded-md border border-solid border-[#E2E8F0] bg-white px-3 text-sm font-medium text-slate-600 transition hover:border-[#CBD5E0] hover:bg-slate-50";

type Props = {
  searchTerm: string;
  filters: PropertyListFilters;
  showConsultantFilter: boolean;
  onSearchChange: (value: string) => void;
  onApplyAdvancedFilters: (filters: PropertyListAdvancedFilters) => void;
};

export function PropertiesListFilters({
  searchTerm,
  filters,
  showConsultantFilter,
  onSearchChange,
  onApplyAdvancedFilters,
}: Props) {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const activeCount = countAdvancedPropertyListFilters(filters);

  return (
    <div className="mb-6 mt-4 flex w-full flex-col gap-3">
      <div className="flex w-full flex-col gap-3 md:flex-row md:flex-wrap md:items-end">
        <PropertiesCodeSearchField />

        <label className="flex min-w-0 flex-1 flex-col gap-1 text-left text-xs font-medium text-slate-600 md:max-w-md">
          Busca
          <input
            className={`${FLOW_TEXT_INPUT_BASE} !font-[inherit]`}
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Informações do imóvel. Ex: bairro, rua, email do proprietário, andar"
          />
        </label>

        <button
          type="button"
          onClick={() => setIsFiltersOpen(true)}
          className={FILTER_ACTION_BUTTON}
        >
          <Filter className="h-4 w-4" aria-hidden />
          Filtros
          {activeCount > 0 ? (
            <span className="inline-flex min-w-5 items-center justify-center rounded-full bg-orange-500 px-1.5 text-[11px] font-semibold text-white">
              {activeCount}
            </span>
          ) : null}
        </button>

        {activeCount > 0 ? (
          <button
            type="button"
            onClick={() =>
              onApplyAdvancedFilters(emptyPropertyListAdvancedFilters())
            }
            className={FILTER_ACTION_BUTTON}
          >
            <FilterX className="h-4 w-4" aria-hidden />
            Limpar filtros
          </button>
        ) : null}
      </div>

      <p className="text-xs text-slate-500">
        A busca atualiza automaticamente. Os demais filtros ficam no botão
        Filtros.
      </p>

      <PropertiesListFiltersModal
        open={isFiltersOpen}
        filters={filters}
        showConsultantFilter={showConsultantFilter}
        onClose={() => setIsFiltersOpen(false)}
        onApply={onApplyAdvancedFilters}
      />
    </div>
  );
}
